module.exports = __webpack_public_path__ + "img/img-13.809afe4f.webp";